<app-template>

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf=" isMobile === false && isTablet === false ">
        <div class="main-fad-empresa">
            <h1>
                <p>FAD® EMPRESARIAL</p>
            </h1>
        </div>

        <div class="you-should max-width">
            <div class="text">
                <h2><p class="principal">
                    Com a FAD® empresarial<br>você pode escolher<br><span>entre 3 opções.</span>
                </p></h2>
                <p class="secondary">
                    E você pode cancelar a qualquer momento.
                </p>
            </div>
            <div class="picture">
                <img src="assets/images/3_opciones.png" alt="Suscripciones">
            </div>
        </div>

        <div class="options-suscriptions">
            <div class="container max-width">
                <div class="item">
                    <mat-card>
                        <div class="image">
                            <img src="assets/images/empresa_sus_mensual.png" alt="FAD Personal">
                            <div class="text">
                                <p>Plano <br><span>Mensal</span></p>
                            </div>
                        </div>
                        <mat-card-content>

                            <div class="characteristic">
                                <p class="light">
                                    Inclui processo patenteado:
                                </p>
                                <p class="bold">
                                    Vídeo Assinatura<br>
                                    Vídeo de aceitação do acordo<br>
                                    Constância de conservação<br>
                                    verificação por número de telefone
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Número de transações:
                                </p>
                                <p class="bold">
                                    Assinaturas ilimitadas
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Suporte:
                                </p>
                                <p class="bold">
                                    N1 Call center de segunda a sexta das 8h às 20h. (N2 com custo extra)
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Inclui:
                                </p>
                                <p class="bold">
                                    App Nativo (iOS e Android)
                                    <br><strong style="font-size: 16px;">* Você pode adquirir Versão Web, SDK e API
                                    separadamente</strong>
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Add-Ons:
                                </p>
                                <p class="bold">
                                    Com custo extra
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Forma de pagamento:
                                </p>
                                <p class="bold">
                                    Cartão de crédito ou débito
                                </p>
                            </div>

                        </mat-card-content>
                    </mat-card>

                    <div class="pricing">
                        <div id="comprar_mensual_empresa" class="option dark full" (click)="callForm(8)">
                            <p>ENTRE EM CONTATO COM UM ASSESSOR</p>
                        </div>
                    </div>

                </div>

                <div class="item">
                    <mat-card>
                        <div class="image">
                            <img src="assets/images/prepago_anual_transaccion.png" alt="FAD Personal">
                            <div class="text">
                                <p style="font-size: 35px; line-height: 40px"><span>Pré-pagamento</span> por transação
                                    com
                                    <span>validade anual</span></p>
                            </div>
                        </div>
                        <mat-card-content>
                            <div class="characteristic principal">
                                <p class="light">
                                    Verifique os preços
                                    <br>com um<br>
                                </p>
                                <p class="bold">
                                    <span>Consultor de Vendas</span>
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Usuários incluídos:
                                </p>
                                <p class="bold">
                                    1
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Número de transações:
                                </p>
                                <p class="bold">
                                    De 11 a 1.000.000
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Validade das transações:
                                </p>
                                <p class="bold">
                                    Anual
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Tipo de transação:
                                </p>
                                <p class="bold" style="font-size: 22px">
                                    Vídeo Assinatura + vídeo de aceitação do acordo + Constância de conservação +
                                    verificação por número de telefone
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Add-Ons:
                                </p>
                                <p class="bold">
                                    Incluído nos diferentes planos
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Forma de pagamento:
                                </p>
                                <p class="bold">
                                    Consulte seu consultor de vendas
                                </p>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    <div class="pricing">
                        <div id="comprar_anual_empresa" class="option dark full" (click)="callForm(4)">
                            <p>ENTRE EM CONTATO COM UM ASSESSOR</p>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <mat-card>
                        <div class="image">
                            <img src="assets/images/integraciones_especiales.png" alt="FAD Personal">
                            <div class="text">
                                <p>Integrações <br> <span>especiais</span></p>
                            </div>
                        </div>
                        <mat-card-content>
                            <div class="characteristic">
                                <p class="light">
                                    Soluções para empresas <br>com necessidades específicas:
                                </p>
                                <p class="bold left">
                                    · API <br>
                                    · SDK <br>
                                    · Troca de imagem<br>
                                    · Integrações especiais<br>
                                    · Entre outros
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Entre em contato<br>
                                    e conte-nos mais sobre o seu projeto:
                                </p>
                                <p class="bold">
                                    <a target="_blank"
                                       href="https://api.whatsapp.com/send?phone=5215527560645&text=Ol%C3%A1,%20tenho%20interesse%20em%20trabalhar%20com%20FAD%20-%20Assinatura%20Aut%C3%B3grafa%20Digital.">+5215527560645</a>
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Nossos assessores<br>
                                    estão disponíveis<br>
                                </p>
                                <p class="bold">
                                    de segunda a sexta-feira,<br> das 10h às 20h.
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Se preferir, você pode preencher o formulário e
                                    <span class="bold">indicar a data e hora</span>
                                    em que <span class="bold">podemos entrar em contato com você.</span>
                                </p>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    <div class="pricing">
                        <div id="comprar_integracion_empresa" class="option dark full" (click)="callForm(5)">
                            <p>PREENCHA O FORMULÁRIO AGORA</p>
                        </div>
                    </div>
                </div>
            </div>
            <div id="contact-cotizar"><p style="color: white;">ancla</p></div>
            <div >
                <div class="options-suscriptions" *ngIf="contactForm === 4 || contactForm === 5 || contactForm === 8">
                    <img class="close" (click)="contactForm = 0" src="assets/images/icon_cross.png" alt="Close">
                    <p class="title max-width" *ngIf="contactForm === 4">
                        Ajude-nos a preencher o formulário para <b>cotar seu plano<br>Pré-pagamento anual à empresa
                        FAD®.</b>
                    </p>
                    <p class="title max-width" *ngIf="contactForm === 5">
                        Ajude-nos a preencher o formulário para <b>falar sobre a sua<br>integração especial FAD®</b>
                    </p>
                    <p class="title max-width" *ngIf="contactForm === 8">
                        Preencha esse formulário para <b>fazer o orçamento do plano<br>de assinatura mensual para empresas</b>
                    </p>
                    <div class="max-width" *ngIf="contactForm === 4">
                        <app-form-company-template [type]="contactForm"></app-form-company-template>
                    </div>
                    <div class="max-width" *ngIf="contactForm === 5">
                        <app-form-company-template [type]="contactForm"></app-form-company-template>
                    </div>
                    <div class="max-width" *ngIf="contactForm === 8">
                        <app-form-company-template [type]="contactForm"></app-form-company-template>
                    </div>
                </div>
            </div>
        </div>

 

        <div class="add-ons">
            <p class="title max-width">
                Tanto no Plano Mensal quanto no Pré-pago,<br>
                você pode adicionar as seguintes<span> Funções extras (Add-Ons) **:</span>
            </p>
            <p style="margin: 20px 0 0; text-align: center; font-size: 20px; margin-top: -15px;">
                <a href="https://api.whatsapp.com/send?phone=5215527560645&text=Ol%C3%A1,%20tenho%20interesse%20em%20trabalhar%20com%20FAD%20-%20Assinatura%20Aut%C3%B3grafa%20Digital." style="font-weight: bold;color: var(--light-gray-color); text-decoration: none; cursor: pointer;">** Para a compra de funcionalidades extras (Add-Ons) solicite-as ao seu consultor de vendas a um custo extra.</a>
            </p>
            <div class="list max-width">
                <div class="left">
                    <p class="title">
                        Recursos extras
                    </p>
                    <div class="table">

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/foto_ine.png" alt="Foto INE">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificação</p>
                                <p class="text-item">Fotografia de identificação em ambos os lados</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/otp_whatsap.png" alt="SMS">
                            </div>
                            <div class="data">
                                <p class="title-item">OTP via WhatsApp</p>
                                <p class="text-item">Envio de código único pelo WhatsApp, para que o signatário abra o
                                    documento a ser assinado no aplicativo móvel ou web</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/blockchain.png" alt="SMS">
                            </div>
                            <div class="data">
                                <p class="title-item">Constância de conservação em Blockchain</p>
                                <p class="text-item">Certificado registrado em Ethereum que garante que o documento
                                    assinado não será alterado</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/version_web.png" alt="SMS">
                            </div>
                            <div class="data">
                                <p class="title-item">Versão WEB</p>
                                <p class="text-item">O signatário pode assinar documentos de qualquer navegador móvel
                                    sem baixar nenhum aplicativo</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/fotoine_firma.png" alt="Ine y Firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificação + validação de assinatura</p>
                                <p class="text-item">Comparação entre a assinatura no documento de identidade e a
                                    assinatura feita com o dedo ou caneta touch</p>
                            </div>
                        </div>

                        <div class="row big">
                            <div class="image">
                                <img src="assets/images/ine_firma_video.png" alt="Ine y Firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificação + validação de assinatura + comparação
                                    facial com vídeo de aceitação do acordo</p>
                                <p class="text-item">Comparação entre a assinatura no documento de identidade e a
                                    assinatura feita com o dedo ou caneta touch, além de uma comparação entre a foto do
                                    rosto
                                    no documento de identidade e uma imagem do rosto do signatário durante o vídeo de
                                    aceitação do acordo</p>
                            </div>
                        </div>

                        <div class="row big">
                            <div class="image">
                                <img src="assets/images/ine_firma_videofirma.png" alt="Ine, video y firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificação + validação de assinatura + comparação
                                    facial com vídeo assinatura </p>
                                <p class="text-item">Comparação entre a assinatura no documento de identidade e a
                                    assinatura feita com o dedo ou caneta touch, além de uma comparação entre a foto do
                                    rosto
                                    capturada no documento de identidade e uma imagem do rosto do signatário durante a
                                    vídeo assinatura</p>
                            </div>
                        </div>

                        <div class="row big">
                            <div class="image">
                                <img src="assets/images/ine_firma_video_validacion.png"
                                     alt="Ine, comparación de firma y video firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificação + validação de assinatura + comparação
                                    facial com vídeo de aceitação do acordo + comparação facial com vídeo assinatura</p>
                                <p class="text-item">Comparação entre a assinatura no documento de identidade e a
                                    assinatura feita com o dedo ou caneta touch; comparação entre a foto do rosto
                                    capturada no
                                    documento de identidade e uma imagem do rosto do signatário durante o vídeo
                                    aceitação do acordo; comparação entre a foto do rosto capturada no documento de
                                    identidade e uma imagem do rosto do signatário durante a vídeo assinatura</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="do-you-wish">
            <p class="title max-width">
                Você está interessado em alguma das nossas<br>
                opções <span>FAD® Empresarial?</span>
            </p>
            <div class="options max-width">
                <div class="item">
                    <img src="assets/images/empresa_mensual.png" alt="Suscripción Mensual">
                    <div class="text">
                        <p>Plano <br><span>Mensal</span></p>
        
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/empresa_prepago.png" alt="Suscripción Mensual">
                    <div class="text">
                        <p>
                            <span>Pré-pagamento anual</span><br>
                            por transação
                        </p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/empresa_integraciones.png" alt="Suscripción Anual">
                    <div class="text">
                        <p>
                            <span>Integrações</span><br>
                            especiais
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="pricing-list-bottom">
            <div class="container max-width">
                <div class="panel">
                    <mat-expansion-panel id="comprar_mensual_resumen" hideToggle (click)="callForm(8)">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>ENTRE EM CONTATO COM UM ASSESSOR</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="content-panel">
                        </div>
                    </mat-expansion-panel>
                </div>
                <div class="panel">
                    <mat-expansion-panel id="comprar_anual_resumen" hideToggle (click)="callForm(4)">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>ENTRE EM CONTATO COM UM ASSESSOR</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="content-panel">

                        </div>
                    </mat-expansion-panel>
                </div>
                <div class="panel">
                    <mat-expansion-panel id="comprar_integracion_resumen" hideToggle (click)="callForm(5)">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>PREENCHA O FORMULÁRIO AGORA</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="content-panel">

                        </div>
                    </mat-expansion-panel>
                </div>
            </div>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">

        <div class="box-container">

            <div class="box-img">
                <img class="img-prin" src="assets/images/m/empresafotos.png">
            </div>

            <div class="content-res">
                <h1>FAD®<br><span>EMPRESARIAL</span><br></h1>
                <hr>
                <h2><p class="text">
                    Com o FAD® Empresarial você pode <strong>escolher entre três opções</strong>
                    e pode <strong>cancelar a qualquer momento.</strong>
                </p></h2>
            </div>

            <div class="box-light">
                <div class="wrapper">
                    <div class="content-res" style="padding-bottom: 0;">
                        <p class="light" style="margin-bottom: 0px;">Plano </p><span>mensal </span><br>
                    </div>
                    <div class="box-product">
                        <div class="description" style="padding-bottom: 0px;">
            
                            <p>Vídeo assinatura + Vídeo de aceitação<br>do acordo + CC NOM 151-2016</p>
                            <p>Suporte N1 Call center de segunda a sexta das 8h às 20h. (N2 com custo extra) </p>
                            <p>App Nativo (iOS e Android)
                                <br><strong style="font-size: 12px;">* Você pode adquirir Versão Web, SDK e API
                                    separadamente</strong></p>
                        </div>
                        <div class="buttons">
                            <div id="comprar_mensual_empresa_movil" class="btn-prin" (click)="callForm(8)">
                                <p>ENTRE EM CONTATO COM UM ASSESSOR</p>
                            </div>
                        </div>
                    </div>
                    <div class="content-res" style="padding-bottom: 0;">
                        <p class="light" style="margin-bottom: 0;">Plano pré-pago com </p>
                        <span>validade anual</span><br>
                    </div>
                    <div class="box-product">
                        <div class="description" style="padding-bottom: 0;">
                        </div>
                        <div class="buttons">
                            <div id="comprar_anual_empresa_movil" class="btn-prin" (click)="callForm(4)">
                                <p>CITE AGORA</p>
                            </div>
                        </div>
                    </div>
                    <div class="content-res" style="padding-bottom: 0px;">
                        <p class="light" style="margin-bottom: 0px;">Integrações </p><span>especiais</span><br>
                    </div>
                    <div class="box-product">
                        <div class="description" style="margin-top: 10px; padding-bottom: 0px;">
                            <p><strong> Entre em contato</strong><br>e conversaremos mais</p>
                            <hr>
                            <p>sobre o seu projeto</p>
                        </div>
                        <div class="buttons">
                            <div id="comprar_integracion_empresa_movil" class="btn-prin" (click)="callForm(5)">
                                <p>ENTRE EM CONTATO COMIGO</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="contact-cotizar-movil">
                <div class="content-general" *ngIf="contactForm === 4 || contactForm === 5 || contactForm === 8">
                    <img class="close" (click)="contactForm = 0" src="assets/images/icon_cross.png" alt="Close">
                    <div class="content-res" *ngIf="contactForm === 4">
                        <p class="title">
                            Ajude-nos a preencher o formulário para <strong>cotar seu plano<br>Pré-pagamento anual à
                            empresa FAD®.</strong>
                    </div>
                    <div class="content-res" *ngIf="contactForm === 5">
                        <p class="title">
                            Ajude-nos a preencher o formulário para <strong>falar sobre a sua<br>integração especial
                            FAD®</strong>
                        </p>
                    </div>
                    <div class="content-res" *ngIf="contactForm === 8">
                        <p class="title">
                            Preencha esse formulário para <strong>fazer o orçamento do plano<br>de assinatura mensual para empresas</strong>
              
                        </p>
                    </div>
                    <div class="content-res" *ngIf="contactForm === 4">
                        <app-form-company-template [type]="contactForm"></app-form-company-template>
                    </div>
                    <div class="content-res" *ngIf="contactForm === 5">
                        <app-form-company-template [type]="contactForm"></app-form-company-template>
                    </div>
                    <div class="content-res" *ngIf="contactForm === 8">
                        <app-form-company-template [type]="contactForm"></app-form-company-template>
                    </div>
                </div>
            </div>

            <div class="content-general">

                <div class="content-res">
                    Conheça as<br><strong>funcionalidades<br>extras do FAD®</strong><br>
                </div>

                <div class="icon">
                    <div class="icon2"></div>
                </div>
                <p class="text"><span>Validação de vídeo de aceitação do acordo</span>
                    <br>Comparação entre o rosto durante o contrato de vídeo e a foto de identificação</p>

                <div class="icon">
                    <div class="icon3"></div>
                </div>
                <p class="text"><span>Validação de Vídeo assinatura </span>
                    <br>Comparação entre o rosto durante a vídeo assinatura e a foto do documento de identidade</p>

                <div class="icon">
                    <div class="icon4"></div>
                </div>
                <p class="text"><span>Constância de blockchain</span>
                    <br>Em Ethereum que garante que o documento assinado não será alterado</p>

                <div class="icon">
                    <div class="icon5"></div>
                </div>
                <p class="text"><span>Captura de identidade</span>
                    <br>Fotografia do documento de identidade em ambos os lados</p>

                <div class="icon">
                    <div class="icon6"></div>
                </div>
                <p class="text"><span>OTP via WhatsApp</span>
                    <br>Envio de código único pelo WhatsApp, para que o signatário abra o documento a ser assinado no
                    app FAD®</p>

                <div class="icon">
                    <div class="icon7"></div>
                </div>
                <p class="text"><span>Validação de assinatura</span>
                    <br>Comparação entre a assinatura no documento de identidade e a assinatura feita com o dedo</p>

                <div class="icon">
                    <div class="icon7"></div>
                </div>
                <p class="text"><span>Versão WEB</span>
                    <br>O signatário pode assinar documentos de qualquer navegador móvel sem baixar nenhum aplicativo
                </p>

                <div class="icon">
                    <div class="icon20"></div>
                </div>
                <p class="text"><span style="color: #a80a34;">Considerações importantes</span>
                    <br>1. Para fazer comparações de contrato de vídeo, assinatura de vídeo e assinatura, é necessário
                    adquirir a Captura de Identificação.<br>
                    2. Para adquirir Add-Ons, solicite-os com seu consultor de vendas por um custo extra.</p>

                <img height="330px" width="266px" src="assets/images/m/telefonos.png" alt="">

            </div>

        </div>

    </div>

</app-template>
